import { AUTH_LOGIN, AUTH_LOGOUT, AUTH_ERROR, AUTH_CHECK, AUTH_GET_PERMISSIONS } from 'react-admin';
import { getPermissionsFromRoles } from '@react-admin/ra-rbac';
import jwt_decode from 'jwt-decode';
import { PermissionErrorPage } from './PermissionErrorPage';
import { loginUrl, permissionsUrl } from '../constants/global';

export default (type, params) => {
    if (type === AUTH_LOGIN) {
        const { email, password } = params;
        const request = new Request(loginUrl, {
            method: 'POST',
            body: JSON.stringify({ email, password }),
            headers: new Headers({ 'Content-Type': 'application/json' }),
        });
        return fetch(request)
            .then(response => {
                if (response.status < 200 || response.status >= 300) {
                    throw new Error(response.statusText);
                }
                return response.json();
            })
            .then(async response => {
                if (response.code === 402) {
                    throw new Error(response.message);  // if user is not active
                }
                if (response.code !== 201) {
                    throw new Error(response.message); // handle other error codes
                } else {
                    // success
                    localStorage.setItem('token', response.payload);

                    // fetch permissions after successful login
                    await fetch(permissionsUrl, {
                        method: 'GET',
                        headers: new Headers({
                            'Authorization': `Bearer ${response.payload}`,
                            'Content-Type': 'application/json'
                        })
                    })
                        .then((response) => response.json())
                        .then((data) => {
                            console.log(data);
                            const tokenData = jwt_decode(response.payload);
                            console.log(tokenData);

                            // Extract organisation ID from the token payload
                            const organisationId = tokenData.organisation;
                            if (organisationId) {
                                localStorage.setItem('organisationId', organisationId);
                                console.log('Organisation ID saved to localStorage:', organisationId);
                            } else {
                                console.error('Organisation ID not found in token payload.');
                            }

                            // calculate expiry time from 'exp' claim
                            const expiryTime = tokenData.exp * 1000; // convert seconds to milliseconds
                            const currentTime = Date.now();
                            localStorage.setItem('expiryTime', expiryTime);
                            localStorage.setItem('currentTime', currentTime);

                            const jsonRoleDefinitions = data;
                            console.log(jsonRoleDefinitions);
                            const jsonRoles = JSON.parse(tokenData.roles);
                            const applications = [
                                ...new Set(
                                    Object.values(data)  // get all modules (arrays of objects)
                                        .flat()            // flatten into a single array
                                        .map(item => item.application) // extract application names
                                )
                            ];
                            const permissions = getPermissionsFromRoles({
                                roleDefinitions: jsonRoleDefinitions,
                                userPermissions: [],
                                userRoles: jsonRoles,
                            });

                            localStorage.setItem('roleDefinitions', JSON.stringify(jsonRoleDefinitions));
                            localStorage.setItem('applications', JSON.stringify(applications));
                            localStorage.setItem('permissions', JSON.stringify(permissions));
                            localStorage.setItem('roles', JSON.stringify(jsonRoles));
                        });

                    return response;
                }
            })
    }

    if (type === AUTH_GET_PERMISSIONS) {
        const permissions = JSON.parse(localStorage.getItem('permissions'));
        return Promise.resolve(permissions);
    }

    if (type === AUTH_LOGOUT) {
        localStorage.removeItem('token');
        localStorage.removeItem('expiryTime');
        localStorage.removeItem('currentTime');
        localStorage.removeItem('roleDefinitions');
        localStorage.removeItem('applications');
        localStorage.removeItem('permissions');
        localStorage.removeItem('roles');
        return Promise.resolve();
    }

    if (type === AUTH_ERROR) {
        const status = params.status;
    
        if (status === 401) {
            // Token expired no authenticated, log the user out
            localStorage.removeItem('token');
            return Promise.reject();
        } else if (status === 403) {
            // Forbidden, authenticated but no permissions
            return Promise.resolve({ redirectTo: '/permission-error' });
        }
    
        return Promise.resolve();
    }
    

    if (type === AUTH_CHECK) {

        // Check if the current route is a public route
        const isPublicRoute = window.location.pathname.startsWith('/public');

        // For public routes, always resolve the authentication check
        if (isPublicRoute) {
            return Promise.resolve();
        }

        const token = localStorage.getItem('token');
        const expiryTime = localStorage.getItem('expiryTime');

        // check if token exists and is not expired
        if (token && expiryTime && parseInt(expiryTime, 10) > Date.now()) {
            return Promise.resolve();
        } else {
            // token is either missing or expired, reject the authentication
            localStorage.removeItem('token');
            localStorage.removeItem('expiryTime');
            return Promise.reject();
        }
    }

    return Promise.resolve();
}
